import template from './app.html';
import './styles/app.less';

let appComponent = {
  template,
  restrict: 'E'
};

export default appComponent;



// WEBPACK FOOTER //
// ./src/app/app.component.js